import { viewSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListTableViewFilter";
import Filter from "@insite/mobius/Icons/Filter";
import Tag from "@insite/mobius/Icons/Tag";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
    `,
};

viewSelectStyles.filterIcon = {
    src: Filter,
    size: 22,
    color: "primary",
};

viewSelectStyles.tagIcon = {
    src: Tag,
    size: 22,
    color: "primary",
};